import { useAuth0 } from '@auth0/auth0-react';

import { useAccountId } from '@zen/App/AccountIdContext/AccountIdContext';
import authStore from '@zen/Auth/authStore';

const useAuth = () => {
  const { isAuthenticated, logout: auth0Logout } = useAuth0();
  const { setAccountId, removeAccountId } = useAccountId();
  const { clearSensitiveData, removeAccountInfo, unsetAccessToken } = authStore();

  const logout = async (): Promise<void> => {
    const { logout: thoughtspotLogout } = await import('@thoughtspot/visual-embed-sdk');

    thoughtspotLogout();
    removeAccountId();
    removeAccountInfo();
    unsetAccessToken();
    auth0Logout({ logoutParams: { returnTo: `${window.location.origin}/dashboard` } });
  };

  return {
    isAuthenticated,
    logout,
    clearSensitiveData,
    loginWithAccountId: (id: string) => setAccountId(id)
  };
};

export default useAuth;
